import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useFooterLinks = () => {
  const { i18n } = useTranslation();
  const [showConsent, setShowConsent] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout>();
  const intervalStart = useRef<number>();

  useEffect(() => {
    intervalStart.current = Date.now();
    intervalRef.current = setInterval(() => {
      if (typeof window.showConsentPreferencesPopup === 'function') {
        setShowConsent(true);
        clearInterval(intervalRef.current);
      } else if (Date.now() > (intervalStart.current + 10000)) {
        clearInterval(intervalRef.current);
      }
    }, 100);
  }, []);

  const footerLinks = useMemo(() => {
    if (!showConsent) return [];
    const cookiesPreferencesLabel = i18n.language?.startsWith('fr') ? 'Préférence de témoins' : 'Cookies preference';
    return [{ text: cookiesPreferencesLabel, onClick: () => { showConsentPreferencesPopup(); } }];
  }, [i18n.language, showConsent]);

  return footerLinks;
};

export default useFooterLinks;
